/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css, FlattenInterpolation, keyframes } from 'styled-components'

import { LoaderProps } from '@customTypes'
import { palette } from '_styles/variables'

const Spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const CubicSpin = keyframes`
  0% {
    transform: rotate(-90deg);
    stroke-dashoffset: ${0.84 * 0.8 * Math.PI}em;
  }
  25% {
    transform: rotate(90deg);
    stroke-dashoffset: ${0.84 * 0.6 * Math.PI}em;
  }
  50% {
    transform: rotate(270deg);
    stroke-dashoffset: ${0.84 * 0.4 * Math.PI}em;
  }
  75% {
    transform: rotate(450deg);
    stroke-dashoffset: ${0.84 * 0.6 * Math.PI}em;
  }
  100% {
    transform: rotate(630deg);
    stroke-dashoffset: ${0.84 * 0.8 * Math.PI}em;
  }
`

const animations: Record<
  Required<LoaderProps>['animation'],
  FlattenInterpolation<any>
> = {
  linear: css`
    stroke-dashoffset: ${() => 0.84 * 0.25 * Math.PI}em;
    animation: ${Spin} 720ms linear infinite;
  `,
  eased: css`
    stroke-dashoffset: ${() => 0.84 * 0.25 * Math.PI}em;
    animation: ${Spin} 720ms infinite;
  `,
  cubic: css`
    animation: ${CubicSpin} 1.5s linear infinite;
  `,
}

type SVGProps = Pick<LoaderProps, 'size' | 'color' | 'progress' | 'animation'>

export const SVG = styled.svg<SVGProps>`
  font-size: ${({ size }) => size};
  width: 1em;
  height: 1em;
  color: ${({ color = palette.brand.pink }) => color};

  & circle {
    font-size: inherit;
    transform-origin: 50% 50%;
    stroke-dasharray: ${Math.PI * 0.84}em;

    &:first-child {
      color: inherit;
      stroke: ${palette.pink[100]};

      &:only-child {
        stroke: currentColor;
        ${({ animation = 'linear' }) => animations[animation]}
      }
    }

    &:last-child:not(:only-child) {
      color: inherit;
      stroke: currentColor;
      transform: rotate(-90deg);
      stroke-dashoffset: ${({ progress = 0 }) =>
        0.84 * (1 - progress / 100) * Math.PI}em;
      transition: 320ms stroke-dashoffset;
    }
  }
`
